import util from '../util'

let controller = 'ParceiroEndereco'
export default Object.assign({}, util.GetCrud(controller, null))
